export default __webpack_public_path__ + "static/media/house-20.1762273c.jpg";